import { Injectable } from '@angular/core'
import { BuilderService } from 'src/app/builder-services/builder.service'
import { CategoriesService } from 'src/app/e-commerce/categories/categories.service'
import { OrdersService } from 'src/app/e-commerce/orders/orders.service'
import { ProductsService } from 'src/app/e-commerce/products/products.service'
import { OdooService } from './odoo/odoo.service'
import { ZohoService } from './zoho/zoho.service'

@Injectable({
  providedIn: 'root'
})
export class SyncerService {
  public syncProgress: any
  constructor(private builderService: BuilderService, private productsService: ProductsService, private categoriesService: CategoriesService, private ordersService: OrdersService, private odooService: OdooService, private zohoService: ZohoService) {}

  // ================= PRODUCTS =================

  syncAllProductsFromWordPress(): void {
    this.builderService.showUpdateProgress = true

    this.productsService.syncAllProductsWP().subscribe(
      (response) => {
        this.builderService.showUpdateProgress = false
      },
      (error) => {
        console.error('❌ Error syncing WordPress products:', error)
        alert('Error syncing WordPress products. Please check console logs.')
        this.builderService.showUpdateProgress = false
      }
    )
  }

  syncAllProductsFromOdoo(): void {
    this.builderService.showUpdateProgress = true
    this.syncProgress = 0

    this.odooService.syncAllProducts().subscribe((res: any) => {
      if (res.done) {
        this.syncProgress = 100
        this.builderService.showUpdateProgress = false
        return
      }
      const progress = Math.round((res.offset / res.total) * 100)
      this.syncProgress = progress
    })
  }

  // ================= CATEGORIES =================

  syncAllCategoriesFromWordPress(): void {
    this.builderService.showUpdateProgress = true

    this.categoriesService.syncAllCategoriesWP().subscribe(
      (response) => {
        this.builderService.showUpdateProgress = false
      },
      (error) => {
        console.error('❌ Error syncing WordPress categories:', error)
        alert('Error syncing WordPress categories. Please check console logs.')
        this.builderService.showUpdateProgress = false
      }
    )
  }

  syncAllCategoriesFromOdoo(): void {
    this.builderService.showUpdateProgress = true

    this.odooService.syncAllCategoriesOdoo().subscribe(
      (response) => {
        this.builderService.showUpdateProgress = false
      },
      (error) => {
        console.error('❌ Error syncing Odoo categories:', error)
        alert('Error syncing Odoo categories. Please check console logs.')
        this.builderService.showUpdateProgress = false
      }
    )
  }

  // ================= ORDERS =================

  syncAllOrdersFromWordPress(): void {
    this.builderService.showUpdateProgress = true

    this.ordersService.syncAllOrdersWP().subscribe(
      (response) => {
        this.builderService.showUpdateProgress = false
      },
      (error) => {
        console.error('❌ Error syncing WordPress orders:', error)
        alert('Error syncing WordPress orders. Please check console logs.')
        this.builderService.showUpdateProgress = false
      }
    )
  }

  // ================= ZOHO =================

  syncZohoItems(): void {
    this.builderService.showUpdateProgress = true

    this.zohoService.getInventoryItems().subscribe(
      () => {
        this.zohoService.saveInventoryItems().subscribe(
          () => {
            this.builderService.showUpdateProgress = false
          },
          (error) => {
            console.error('❌ Error saving Zoho items:', error)
            alert('Error saving Zoho items. Please check console logs.')
            this.builderService.showUpdateProgress = false
          }
        )
      },
      (error) => {
        console.error('❌ Error fetching Zoho items:', error)
        alert('Error fetching Zoho items. Please check console logs.')
        this.builderService.showUpdateProgress = false
      }
    )
  }
}
